module.exports = __webpack_public_path__ + "img/receipt.2fddeb84.svg";